<template>
<!-- 收藏也的trial item -->
  <div class="trialCollectionItem">
    <el-timeline :reverse="false">
      <el-timeline-item
        color="#6a9edd"
        v-for="(value, index) in timelineData"
        :key="index"
      >
      <p class="timeLine">{{ index }}</p>
      <ul>
        <li class="infoLi" v-for="(item, index1) in value" :key="index1">
          <TrialItem :trialItemData="item"></TrialItem>
        </li>
      </ul>
      </el-timeline-item>
    </el-timeline>
    <div class="noData" v-show="isEmpty">
      <img src="../assets/img/empty.png" alt="" />
      <span class="text">空空如也，没有收藏任何研究哦~</span>
    </div>
    <div class="page">
      <el-pagination
        background
        hide-on-single-page
        :current-page="pageNum"
        :page-size="pageSize"
        @current-change="handleCurrentChange"
        layout="prev, pager, next"
        :total="totalNum"
      >
      </el-pagination>
    </div>
  </div>
</template>
<script>
import TrialItem from './TriaItem.vue'
import { trialCollect } from '../service/getData'
export default {
  components: {
    TrialItem
  },
  data() {
    return {
      timelineData: {},
      totalNum: 0,
      pageSize: 10,
      pageNum: 1,
      isEmpty: false,
    }
  },
  methods: {
    /**
     * 获取搜索列表
     */
    async getCollection() {
      let params = {
        page: this.pageNum,
        limit: this.pageSize
      }
      const res = await trialCollect('GET',params);
      if (res && res.data.status == 0) {
        this.totalNum = res.data.count;
        if(this.totalNum == 0) {
          this.isEmpty = true;
          return;
        }
        this.isEmpty = false;
        const timelineData = {};
        res.data.data.forEach((item) => {
          const collect_date = item.collect_time.substring(0, 10);
          timelineData[collect_date] = [];
        });
        res.data.data.forEach((item, index) => {
          const collect_date = item.collect_time.substring(0, 10);
          if (timelineData[collect_date]) {
            timelineData[collect_date].push(item)
          }
        })
        this.timelineData = timelineData;
      } else {
        this.timelineData = {};
      }
    },
    handleCurrentChange(val) {
      this.pageNum = val;
      window.scroll(0, 0);
      this.getCollection();
    },
  },
  created() {
    this.getCollection();
  },
  
}
</script>
<style lang="less" scoped>
.trialCollectionItem{
  width: 1000px;
  margin: 0 auto;
  margin-top: 20px;

  /deep/.el-timeline-item__tail {
    left: -16px;
    height: 100% !important;
    border: 1px dashed #ebebeb;
  }
  .timeLine{
    font-size: 14px;
    color: #4586d5;
    padding-left: 24px;
    background: url("../assets/img/collection2.png") no-repeat 0 center;
    margin-bottom: 10px;
  }
  .infoLi {
    position: relative;
    border: 1px solid #ccc;
    margin-top: -1px;
    padding: 10px;
  }
  .noData {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .text {
      color: #ccc;
      margin-top: 10px;
      font-size: 14px;
    }
  }
  .page {
    display: flex;
    justify-content: center;
    margin-top: 30px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/TrialCollectionItem.vue